(function () {
  "use strict";

  function ready(callback) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", callback, { once: true });
    else callback();
  }

  ready(function () {
    var roots = document.querySelectorAll(".campaign-pricing");
    if (!roots.length) return;
    var compactViewport = window.matchMedia("(min-width: 1024px) and (max-height: 800px)");

    function buildMobileCards(root) {
      var table = root.querySelector(".campaign-pricing-table");
      var targets = root.querySelectorAll("[data-campaign-mobile-features]");
      if (!table || targets.length !== 3) return;

      var rows = table.querySelectorAll("tbody tr");
      var completed = 0;
      targets.forEach(function (target) {
        var planIndex = parseInt(target.dataset.campaignMobileFeatures, 10);
        var count = 0;
        target.textContent = "";

        rows.forEach(function (row) {
          if (row.classList.contains("campaign-feature-cta")) return;
          if (row.classList.contains("campaign-feature-category")) {
            var sourceCategory = row.querySelector("th");
            if (!sourceCategory) return;
            var category = document.createElement("h4");
            category.className = "campaign-mobile-feature-category";
            category.textContent = sourceCategory.textContent.trim();
            target.appendChild(category);
            return;
          }

          var sourceDetails = row.querySelector("th[scope='row'] details");
          var planCell = row.querySelectorAll("td")[planIndex];
          if (!sourceDetails || !planCell) return;
          var sourceSummary = sourceDetails.querySelector("summary");
          var sourceCopy = sourceDetails.querySelector("p");
          if (!sourceSummary || !sourceCopy) return;

          var details = document.createElement("details");
          details.className = "campaign-mobile-feature";
          var summary = document.createElement("summary");
          var title = document.createElement("span");
          title.className = "campaign-mobile-feature-title";
          title.textContent = sourceSummary.textContent.trim();
          var status = document.createElement("span");
          status.className = "campaign-mobile-feature-status";
          Array.prototype.forEach.call(planCell.childNodes, function (node) { status.appendChild(node.cloneNode(true)); });
          var copy = document.createElement("div");
          copy.className = "campaign-mobile-feature-copy";
          copy.appendChild(sourceCopy.cloneNode(true));
          summary.appendChild(title);
          summary.appendChild(status);
          details.appendChild(summary);
          details.appendChild(copy);
          target.appendChild(details);
          count += 1;
        });
        if (count) completed += 1;
      });
      if (completed === targets.length) root.classList.add("is-mobile-ready");
    }

    function syncStickyOffset(root) {
      var bottom = 0;
      var selectors = [".top-bar", ".df-sticky-bar", ".deadline-funnel-sticky-bar", "[data-df-sticky]"];
      document.querySelectorAll(selectors.join(",")).forEach(function (bar) {
        var style = window.getComputedStyle(bar);
        var rect = bar.getBoundingClientRect();
        if ((style.position === "fixed" || style.position === "sticky") && rect.top <= 1 && rect.bottom > 0) {
          bottom = Math.max(bottom, Math.round(rect.bottom));
        }
      });
      root.style.setProperty("--campaign-sticky-top", bottom + "px");
      var table = root.querySelector(".campaign-pricing-table");
      if (!table) return;
      // Measure the natural table top, not the header that changes height.
      // Keep a small exit tolerance; native sticky handles the table bottom.
      var tolerance = root.classList.contains("is-compact-sticky") ? 2 : 0;
      root.classList.toggle("is-compact-sticky", compactViewport.matches &&
        table.getBoundingClientRect().top <= bottom + tolerance);
    }

    var activeRoot = null;
    var activeModal = null;
    var lastTrigger = null;
    var lastPlan = "";

    function checkedBooks(modal) {
      return Array.prototype.map.call(modal.querySelectorAll(".book-check:checked"), function (input) { return input.dataset.section; });
    }

    function dispatchBookChange(modal) {
      var input = modal.querySelector(".book-check");
      if (input) input.dispatchEvent(new Event("change", { bubbles: true }));
    }

    function prepareBooks(modal, plan) {
      var cores = ["FAR", "AUD", "REG"];
      var disciplines = ["BAR", "ISC", "TCP"];
      var inputs = modal.querySelectorAll(".book-check");

      if (lastPlan === "unlimited-plus" && plan !== "unlimited-plus") {
        inputs.forEach(function (input) { input.checked = false; });
      }

      if (plan === "unlimited-plus") {
        var selectedDiscipline = "";
        inputs.forEach(function (input) {
          if (input.checked && disciplines.indexOf(input.dataset.section) !== -1) selectedDiscipline = input.dataset.section;
        });
        inputs.forEach(function (input) {
          var section = input.dataset.section;
          input.checked = cores.indexOf(section) !== -1 || Boolean(selectedDiscipline && section === selectedDiscipline);
          input.disabled = cores.indexOf(section) !== -1;
        });
      } else {
        inputs.forEach(function (input) { input.disabled = false; });
      }
      lastPlan = plan;
      dispatchBookChange(modal);
    }

    function syncModal(modal) {
      var plan = modal.dataset.activePlan || "unlimited";
      var selected = checkedBooks(modal);
      var disciplines = ["BAR", "ISC", "TCP"];
      var hasDiscipline = selected.some(function (book) { return disciplines.indexOf(book) !== -1; });
      var title = modal.querySelector(".campaign-pricing-modal-title");
      var description = modal.querySelector(".campaign-pricing-modal-description");
      var checkout = modal.querySelector(".campaign-modal-checkout");
      var total = modal.querySelector("[data-campaign-book-total]");
      var primary = modal.querySelector(".campaign-modal-checkout-primary");
      var sub = modal.querySelector(".campaign-modal-checkout-sub");
      var message = modal.querySelector(".campaign-discipline-message");

      modal.querySelectorAll(".book-row-inner").forEach(function (row) {
        var input = row.querySelector(".book-check");
        row.classList.toggle("is-checked", Boolean(input && input.checked));
      });

      if (title) title.textContent = plan === "monthly" ? "ADD PRINTED TEXTBOOKS TO MONTHLY" : (plan === "unlimited-plus" ? "CHOOSE YOUR FOURTH TEXTBOOK" : "ADD PRINTED TEXTBOOKS TO COMPLETE");
      if (description) {
        description.textContent = plan === "unlimited-plus"
          ? "FAR, AUD, and REG are included. Choose BAR, ISC, or TCP to complete your four-book set, then confirm all four on the secure order form."
          : "Printed Textbooks are optional at $125 each. Choose any books you want, or continue with the complete digital course only. Confirm selected books on the secure order form.";
      }

      if (message) message.hidden = plan !== "unlimited-plus" || hasDiscipline;
      if (total) {
        total.textContent = plan === "unlimited-plus"
          ? (hasDiscipline ? "Four Printed Textbooks included" : "Choose one Discipline book")
          : (selected.length ? selected.length + " book" + (selected.length === 1 ? "" : "s") + " · +$" + (selected.length * 125) : "Digital course only · $0 in books");
      }
      if (checkout) checkout.setAttribute("aria-disabled", plan === "unlimited-plus" && !hasDiscipline ? "true" : "false");
      if (primary) {
        primary.textContent = plan === "monthly" ? "CONTINUE WITH MONTHLY" : (plan === "unlimited-plus" ? "CONTINUE WITH COMPLETE + 4 TEXTBOOKS" : "CONTINUE WITH COMPLETE");
      }
      if (sub) {
        sub.textContent = plan === "unlimited-plus"
          ? "Confirm FAR, AUD, REG, and your Discipline on the secure order form"
          : (selected.length ? "Your selected books will be highlighted for confirmation at checkout" : "Continue with the complete digital course and no Printed Textbooks");
      }
    }

    function openBookModal(trigger) {
      if (!trigger) return false;
      var root = trigger.closest(".campaign-pricing");
      if (!root) return false;
      var modal = root.querySelector(".campaign-pricing-modal");
      if (!modal) return false;

      var plan = trigger.dataset.ctaPlan || "unlimited";
      var title = modal.querySelector(".campaign-pricing-modal-title");
      var description = modal.querySelector(".campaign-pricing-modal-description");
      var checkout = modal.querySelector(".campaign-modal-checkout");
      activeRoot = root;
      activeModal = modal;
      lastTrigger = trigger;
      modal.dataset.activePlan = plan;

      if (title) title.textContent = plan === "monthly" ? "ADD PRINTED TEXTBOOKS TO MONTHLY" : (plan === "unlimited-plus" ? "CHOOSE YOUR FOURTH TEXTBOOK" : "ADD PRINTED TEXTBOOKS TO COMPLETE");
      if (description) {
        description.textContent = plan === "unlimited-plus"
          ? "FAR, AUD, and REG are included. Choose BAR, ISC, or TCP to complete your four-book set, then confirm all four on the secure order form."
          : "Printed Textbooks are optional at $125 each. Choose any books you want, or continue with the complete digital course only. Confirm selected books on the secure order form.";
      }
      if (checkout) {
        var base = trigger.dataset.baseHref || trigger.getAttribute("href");
        checkout.dataset.ctaPlan = plan;
        checkout.dataset.baseHref = base;
        checkout.setAttribute("href", trigger.getAttribute("href"));
      }

      prepareBooks(modal, plan);
      syncModal(modal);
      modal.querySelector(".campaign-pricing-modal-body").scrollTop = 0;
      if (typeof modal.showModal === "function") modal.showModal();
      else {
        modal.setAttribute("open", "");
        modal.classList.add("is-fallback-open");
      }
      document.documentElement.style.overflow = "hidden";
      window.setTimeout(function () {
        var close = modal.querySelector(".campaign-pricing-modal-close");
        if (close) close.focus({ preventScroll: true });
      }, 0);
      return true;
    }

    function closeModal(modal) {
      if (!modal) return;
      if (typeof modal.close === "function" && modal.open) modal.close();
      else {
        modal.removeAttribute("open");
        modal.classList.remove("is-fallback-open");
      }
      document.documentElement.style.removeProperty("overflow");
      if (lastTrigger && typeof lastTrigger.focus === "function") lastTrigger.focus();
    }

    window.KeslerCampaignPricing = { openBookModal: openBookModal };

    roots.forEach(function (root) {
      buildMobileCards(root);
      syncStickyOffset(root);
      var frame = null;
      function requestStickySync() {
        if (frame !== null) return;
        frame = window.requestAnimationFrame(function () { frame = null; syncStickyOffset(root); });
      }
      window.addEventListener("scroll", requestStickySync, { passive: true });
      window.addEventListener("resize", requestStickySync);

      var modal = root.querySelector(".campaign-pricing-modal");
      if (!modal) return;
      modal.querySelectorAll(".book-check").forEach(function (input) {
        input.addEventListener("change", function () {
          if (modal.dataset.activePlan === "unlimited-plus" && ["BAR", "ISC", "TCP"].indexOf(input.dataset.section) !== -1 && input.checked) {
            modal.querySelectorAll(".book-check").forEach(function (other) {
              if (other !== input && ["BAR", "ISC", "TCP"].indexOf(other.dataset.section) !== -1) other.checked = false;
            });
          }
          syncModal(modal);
        });
      });
      var clear = modal.querySelector(".campaign-book-clear");
      if (clear) clear.addEventListener("click", function () {
        if (modal.dataset.activePlan === "unlimited-plus") {
          modal.querySelectorAll(".book-check").forEach(function (input) {
            input.checked = ["FAR", "AUD", "REG"].indexOf(input.dataset.section) !== -1;
          });
        } else modal.querySelectorAll(".book-check").forEach(function (input) { input.checked = false; });
        dispatchBookChange(modal);
        syncModal(modal);
      });
      var close = modal.querySelector(".campaign-pricing-modal-close");
      if (close) close.addEventListener("click", function () { closeModal(modal); });
      modal.addEventListener("click", function (event) { if (event.target === modal) closeModal(modal); });
      modal.addEventListener("close", function () {
        document.documentElement.style.removeProperty("overflow");
        if (lastTrigger && typeof lastTrigger.focus === "function") lastTrigger.focus();
      });
      var checkout = modal.querySelector(".campaign-modal-checkout");
      if (checkout) checkout.addEventListener("click", function (event) {
        if (checkout.getAttribute("aria-disabled") === "true") {
          event.preventDefault();
          var message = modal.querySelector(".campaign-discipline-message");
          if (message) message.hidden = false;
          var first = modal.querySelector(".campaign-book-discipline .book-check");
          if (first) first.focus();
        }
      });
    });
  });
})();
